// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uLGI","signatureBlock":"Footer_signatureBlock__3fWuW","signature":"Footer_signature__3zvwk"};